import ConfirmModal from "@components/ConfirmModal";
import { message } from "antd";
import { QueryClient } from "react-query";
import { createRoot } from "react-dom/client";
import { format } from "date-fns";
import { handleExport } from "@global/handleExport";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const SET_LOADING = "SET_LOADING";
export const MODE = "MODE";


export const login = () => ({
  type: LOGIN,
});

export const logout = () => ({
  type: LOGOUT,
});

export const setLoading = (isLoading) => ({
  type: SET_LOADING,
  payload: isLoading,
});
export function float(amount) {
  if (isNaN(amount) === true) {
    return amount;
  }
  var nStr = parseFloat(amount).toFixed(2);
  return parseFloat(nStr);
}
export const toggleMode = (newMode) => ({
  type: MODE,
  payload: newMode,
});
export const sleep = async (milliseconds) => {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
};

export const removeElements = (className) => {
  let get = document.querySelectorAll("." + className);
  get.forEach((element) => {
    element.remove();
  });
};

export function isEmail(email) {
  var e = new RegExp(
    /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
  );
  return e.test(email);
}

export function iqueryClient() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false,
      },
    },
  });

  queryClient.clear();

  return queryClient;
}
export function isValidUrl(urlString) {
  var urlPattern = new RegExp(
    "^(https?:\\/\\/)?" + // validate protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // validate domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // validate OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // validate port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // validate query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // validate fragment locator
  return !!urlPattern.test(urlString);
}

export function ceil(amount) {
  if (isNaN(amount) == true) {
    return amount;
  }
  return Math.ceil(amount);
}

export function error(msg) {
  message.error(msg);
}

export function success(msg) {
  message.success(msg);
}

export function isUddi(uddiKey) {
  if (!uddiKey) {
    return false;
  }

  // Expression régulière pour un UUID version 4 (RFC 4122)
  const e = new RegExp(
    /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i // 'i' pour insensibilité à la casse (majuscules/minuscules)
  );

  return e.test(uddiKey.toUpperCase());
}
export function ucfirst(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function dateFrEn(date) {
  const dt = date.split(" ");
  const d = dt[0].split("/");
  var newDate = d[2] + "-" + d[1] + "-" + d[0];
  if (dt[1]) {
    newDate = newDate + " " + dt[1];
  }

  return newDate;
}

export const daysInMonth = (year, month) => new Date(year, month, 0).getDate();

export function monthNow() {
  var month = new Date().getMonth() + 1;
  if (month < 10) {
    month = "0" + month;
  }
  return month;
}

export function lastDayCurrentMonth() {
  var month = monthNow();
  return (
    daysInMonth(new Date().getFullYear(), month) +
    "/" +
    month +
    "/" +
    new Date().getFullYear()
  );
}

export function firstDayCurrentMonth() {
  var month = monthNow();
  return "01/" + month + "/" + new Date().getFullYear();
}

export function firstDayYear() {
  return "01/01/" + new Date().getFullYear();
}
export function date_now() {
  return new Date().toLocaleDateString("fr-FR");
}

export function confirm(props) {
  props.useModal.setSize("md");
  props.useModal.setTitle(props.title);
  props.useModal.openModal(
    <ConfirmModal
      params={props.params}
      messageConfirm={props.messageConfirm}
      closeModal={props.useModal.closeModal}
      handleChange={props.handleChange}
    />
  );
}

export function innerComponent(component, classRemove, elmentcreate = "div") {
  removeElements(classRemove);
  sleep(5000);
  const domNode = document.createElement(elmentcreate);
  domNode.setAttribute("class", classRemove);
  const root = createRoot(domNode);
  root.render(component);
  return domNode;
}

export function nextDate(dateFrom, nb) {
  var tmp = new Date(dateFrom).getTime();
  var tmp_next = tmp + 86400000 * nb;
  return format(tmp_next, "yyyy-MM-dd");
}
export function previousDate(dateFrom, nb) {
  var tmp = new Date(dateFrom).getTime();
  var tmp_next = tmp - 86400000 * nb;
  return format(tmp_next, "yyyy-MM-dd");
}

export function nexTime(dateFrom, nb) {
  var tmp = new Date(dateFrom).getTime();
  var tmp_next = tmp + 86400000 * nb;
  return tmp_next;
}
export function previousTime(dateFrom, nb) {
  var tmp = new Date(dateFrom).getTime();
  var tmp_next = tmp - 86400000 * nb;
  return tmp_next;
}

export const downloadExcel = async (type, titleName, data, columnsExcel) => {
  handleExport(type, titleName, data, columnsExcel).then((url) => {
    const downloadAnchorNode = document.createElement("a");
    downloadAnchorNode.setAttribute("href", url);
    downloadAnchorNode.setAttribute("download", titleName + ".xlsx");
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
    window.wait(0);
  });
};

export function array_sum(array) {
  const initialValue = 0;
  const sumWithInitial = array.reduce(
    (accumulator, currentValue) => accumulator + currentValue,
    initialValue
  );

  return sumWithInitial;
}

/**
 * formater les montants
 * @param {float} amount
 * @returns
 */
export function money(amount) {
  if (isNaN(amount) === true) {
    return amount;
  }
  var nStr = float(amount);

  nStr += "";
  var x = nStr.split(".");
  var x1 = x[0];
  var x2 = x.length > 1 ? "," + x[1] : "";
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, "$1" + " " + "$2");
  }
  if (x2 === "") {
    x2 = ",00";
  }
  return x1 + x2;
};


